import Home from './Home.pid-bank-lists.vue'

export default {
  Home
}